import React from 'react';
import { useNavigate } from 'react-router-dom';

const AdminOverview = ({ offers, packages }) => {
  const navigate = useNavigate();
  
  const stats = [
    {
      title: 'Ponude',
      icon: '📋',
      count: offers.length,
      desc: 'Upravljajte ponudama za klijente',
      path: '/admin/offers',
      color: 'bg-blue-50 text-blue-600'
    },
    {
      title: 'Kalendar',
      icon: '📅',
      count: offers.filter(o => o.datum).length,
      desc: 'Pregled rasporeda i termina',
      path: '/admin/calendar',
      color: 'bg-emerald-50 text-emerald-600'
    },
    {
      title: 'Paketi',
      icon: '🎁',
      count: packages.length,
      desc: 'Kreirajte i uređujte pakete usluga',
      path: '/admin/packages',
      color: 'bg-purple-50 text-purple-600'
    },
    {
      title: 'Postavke',
      icon: '⚙️',
      count: null,
      desc: 'Email, društvene mreže i kontakt',
      path: '/admin/settings',
      color: 'bg-gray-50 text-black'
    }
  ];

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-playfair font-black text-black">DOBRODOŠLI NAZAD</h1>
        <p className="text-black font-medium italic">Pregled vašeg vjenčanog studija</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {stats.map((stat, idx) => (
          <div 
            key={idx}
            onClick={() => navigate(stat.path)}
            className="group relative p-8 bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl hover:border-black transition-all duration-300 cursor-pointer overflow-hidden"
          >
            <div className={`absolute top-0 right-0 w-32 h-32 -mr-8 -mt-8 rounded-full opacity-10 ${stat.color.split(' ')[0]} group-hover:scale-150 transition-transform duration-500`} />
            
            <div className="relative z-10">
              <div className="text-4xl mb-6">{stat.icon}</div>
              <h3 className="text-xl font-playfair font-black text-black mb-2 uppercase tracking-wide">{stat.title}</h3>
              <p className="text-black text-sm mb-8 font-medium">{stat.desc}</p>
              
              <div className="flex justify-between items-center">
                {stat.count !== null && (
                  <div className="flex flex-col">
                    <span className="text-[10px] text-black uppercase tracking-[0.2em] font-bold">Ukupno</span>
                    <span className="text-2xl font-black text-black">{stat.count}</span>
                  </div>
                )}
                <div className="ml-auto bg-black text-white p-3 rounded-2xl group-hover:bg-gray-800 transition-colors">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminOverview;
